import { EarningsInsight } from '@toggle/toggle';

import { parseEarningsInsights } from '~/react-query-hooks/insights/useEarningsInsightsFilter.utils';

export const deduplicateEarningsInsights = (
  insights: EarningsInsight[]
): EarningsInsight[] => {
  const groupedByEarningsId = new Map<string, EarningsInsight[]>();

  insights.forEach(insight => {
    const earningsId = insight.earnings_id;

    if (!groupedByEarningsId.has(earningsId)) {
      groupedByEarningsId.set(earningsId, []);
    }

    const group = groupedByEarningsId.get(earningsId);

    if (group) {
      group.push(insight);
    }
  });

  const deduplicated: EarningsInsight[] = [];

  groupedByEarningsId.forEach(groupedInsights => {
    const parsedEarningsInsight = parseEarningsInsights(groupedInsights);

    if (parsedEarningsInsight) {
      deduplicated.push(parsedEarningsInsight);
    }
  });

  return deduplicated;
};
